import { FeedSetupSlice } from "./FeedSetup.slice";

export default FeedSetupSlice.reducer;
